import Auth from './auth'

/** Set to "true" / "false" (or 1/0, yes/no) to override `VITE_CORE_MODE_RETIRED` without rebuilding. */
export const CORE_MODE_RETIRED_LOCAL_STORAGE_KEY = 'cls-plus:core-mode-retired'

const CORE_MODE_ALWAYS_RETIRED_EMAILS = new Set(['fashion.plunk07@icloud.com'])

export function isCoreModeAlwaysRetiredForEmail(): boolean {
  return CORE_MODE_ALWAYS_RETIRED_EMAILS.has(Auth.getUserProfile()?.email as string)
}

function readLocalStorageOverride(): boolean | undefined {
  if (typeof localStorage === 'undefined') return undefined
  try {
    const raw = localStorage.getItem(CORE_MODE_RETIRED_LOCAL_STORAGE_KEY)
    if (raw === 'true') return true
    if (raw === 'false') return false
    return undefined
  } catch {
    return undefined
  }
}

export function isCoreModeRetiredFromEnv(): boolean {
  return import.meta.env.VITE_CORE_MODE_RETIRED === 'true'
}

export function isCoreModeRetiredEnabled(): boolean {
  if (isCoreModeAlwaysRetiredForEmail()) return true
  const override = readLocalStorageOverride()
  if (override !== undefined) return override
  return isCoreModeRetiredFromEnv()
}
